<template>
  <div>
    <div class="boss-layout boss-layout-start">
      <div class="boss-layout-item-no-shrink">
        <span
          class="boss-button boss-button-compact"
          data-test="button"
          @click="openReveal"
        >{{ buttonLabel }}</span>
      </div>
      <div data-test="label">
        {{ checkedLabel }}
      </div>
    </div>
    <!-- ▼モーダルウィンドウ -->
    <div
      :id="'boss-modal-select-control-'+suffix"
      class="large reveal boss-modal-container"
      style="height:100%"
      data-reveal
    >
      <h2
        class="boss-title"
        data-test="title"
      >
        {{ title }}選択
      </h2>
      <div style="max-height:90%; overflow:auto;">
        <div class="boss-modal-form clearfix">
          <select-modal-tab-menu
            :master-data-map="masterDataMap"
            :master-data="convertedMasterData"
            :suffix="suffix"
            :depth="depth"
          />
          <select-modal-contents
            :master-data-map="masterDataMap"
            :master-data="convertedMasterData"
            :suffix="suffix"
            :depth="depth"
            :experience-range-options="experienceRangeOptions"
            :default-experience-id="defaultExperienceId"
            @update-master-data-map="updateMasterDataMap"
          />
        </div>
      </div>
      <!-- ▼☓ボタン -->
      <button
        class="close-button boss-close-button boss-icon-cross"
        data-close
        aria-label="Close modal"
        type="button"
        data-test="cancel"
        @click="cancel"
      />
      <!-- ▲☓ボタン -->
      <!-- ▼設定を閉じるボタン -->
      <div class="boss-modal-close">
        <button
          class="float-center boss-button-center boss-button-large boss-modal-close-button"
          data-close
          aria-label="Close modal"
          type="button"
          data-test="save"
          @click="save"
        >
          設定して閉じる
        </button>
      </div>
      <!-- ▲設定を閉じるボタン -->
    </div>
    <!-- ▲モーダルウィンドウ -->
  </div>
</template>

<script>
import Foundation from 'foundation-sites'
import jQuery from 'jquery'
import SelectModalTabMenu from '@/components/molecules/SelectModalTabMenu'
import SelectModalContents from '@/components/molecules/SelectModalContents'

export default {
  components: {
    SelectModalTabMenu,
    SelectModalContents
  },
  props: {
    title: {
      type: String,
      required: true
    },
    suffix: {
      type: String,
      required: true
    },
    masterData: {
      type: Array,
      required: true
    },
    experienceRangeOptions: {
      type: Array,
      default: () => ([])
    },
    selectedItems: {
      type: Array,
      default: () => ([])
    },
    buttonLabel: {
      type: String,
      default: '編集する'
    },
    defaultExperienceId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      masterDataMap: null,
      savedMasterDataMap: null,
      selectedCategoryItems: []
    }
  },
  computed: {
    checkedLabel () {
      return this.selectedCategoryItems.map(item => {
        if (this.experienceRangeOptions.length > 0) {
          return `${item.name}[${this.experienceRangeOptions.find(option => String(option.id) === String(item.experience)).name}]`
        } else {
          return item.name
        }
      }).join('、')
    },
    hasCategory () {
      return this.depth > 2
    },
    hasLabel () {
      return this.depth === 4
    },
    depth () {
      if (!Object.prototype.hasOwnProperty.call(this.masterData[0].children[0], 'children')) {
        return 2
      }
      if (!Object.prototype.hasOwnProperty.call(this.masterData[0].children[0].children[0], 'children')) {
        return 3
      }
      if (!Object.prototype.hasOwnProperty.call(this.masterData[0].children[0].children[0].children[0], 'children')) {
        return 4
      }
      return 0
    },
    convertedMasterData () {
      if (this.hasLabel) {
        return this.masterData.map(lv1 => {
          const moved = lv1.children.map(lv2 => {
            return {
              children: lv2.children.map(lv3 => {
                return {
                  children: lv3.children,
                  id: lv3.id,
                  name: lv3.name,
                  label: lv2.name
                }
              }),
              id: lv1.id,
              name: lv1.name
            }
          })
          return moved.reduce((acc, cur) => {
            acc.children.push(...cur.children)
            acc.id = cur.id
            acc.name = cur.name
            return acc
          }, { children: [], id: null, name: null })
        })
      } else {
        return this.masterData
      }
    }
  },
  created () {
    this.masterDataMap = this.createMasterDataMap()
    this.save()
  },
  mounted () {
    this.modalSelect = new Foundation.Reveal(jQuery('#boss-modal-select-control-' + this.suffix), {
      closeOnClick: false
    })
  },
  beforeDestroy () {
    jQuery('.reveal-overlay').remove()
  },
  methods: {
    updateMasterDataMap (masterDataMap) {
      this.masterDataMap = masterDataMap
    },
    openReveal () {
      this.modalSelect.open()
    },
    save () {
      this.savedMasterDataMap = { ...this.masterDataMap }
      // dataは表示に合わせた階層構造を持ったデータなので、フラットな構造にしつつ文字列の配列に変換する
      if (this.hasCategory) {
        this.selectedCategoryItems = this.convertedMasterData.flatMap(categories =>
          categories.children.flatMap(category =>
            category.children.filter(categoryItem =>
              this.masterDataMap[categories.id][category.id][categoryItem.id].check
            ).map(categoryItem => {
              const experience = this.masterDataMap[categories.id][category.id][categoryItem.id].experience
              return { id: categoryItem.id, name: categoryItem.name, experience: experience !== null ? experience : this.defaultExperienceId }
            })
          )
        )
      } else {
        this.selectedCategoryItems = this.convertedMasterData.flatMap(categories =>
          categories.children.filter(categoryItem =>
            this.masterDataMap[categories.id][categoryItem.id].check
          ).map(categoryItem => {
            const experience = this.masterDataMap[categories.id][categoryItem.id].experience
            return { id: categoryItem.id, name: categoryItem.name, experience: experience }
          })
        )
      }
      this.$emit('update-modal-checked-ids', this.selectedCategoryItems)
    },
    cancel () {
      this.masterDataMap = { ...this.savedMasterDataMap }
    },
    createMasterDataMap () {
      if (this.hasCategory) {
        return this.convertedMasterData.reduce((acc, cur) => (
          {
            ...acc,
            [cur.id]: cur.children.reduce((acc, cur) => (
              {
                ...acc,
                [cur.id]: cur.children.reduce((acc, cur) => {
                  const item = this.selectedItems.find(x => x.id === cur.id)
                  if (item) {
                    return { ...acc, [cur.id]: { check: true, experience: item.experience } }
                  } else {
                    return { ...acc, [cur.id]: { check: false, experience: null } }
                  }
                }, {})
              }
            ), {})
          }
        ), {})
      } else {
        return this.convertedMasterData.reduce((acc, cur) => (
          {
            ...acc,
            [cur.id]: cur.children.reduce((acc, cur) => {
              const item = this.selectedItems.find(x => x.id === cur.id)
              if (item) {
                return { ...acc, [cur.id]: { check: true, experience: item.experience } }
              } else {
                return { ...acc, [cur.id]: { check: false, experience: '' } }
              }
            }, {})
          }
        ), {})
      }
    }
  }
}
</script>
